export enum UserDetailTabType {
  USER_INFO = 'user-info',
  CALENDAR = 'calendar',
  REPORTS = 'reports',
  // The public route stays stable even though its visible label is Hormone Trends.
  HORMONE_CHARTS = 'hormone-charts',
  BASELINES = 'baselines',
  SCANS = 'scans',
  AUDIT_ACTIVITY = 'audit-activity',
  NOTIFICATIONS = 'notifications',
  SCANNING_PLAN_HISTORY = 'scanning-plan-history',
  SUBSCRIPTIONS = 'subscriptions',
  HORMONE_PATTERN = 'hormone-pattern',
  REPRODUCTIVE_STAGE = 'reproductive-stage',
  USER_CYCLES = 'user-cycles',
  OVULATORY_EVENT_PREDICTION = 'ovulatory-event-prediction',
}
